<template>
  <div class="input-block">
    <label>
      Type
      <span class="required">*</span>
      <tooltip :text="TOOLTIP_TEXT.TYPE_FIELD"></tooltip>
    </label>
    <select name="type" required @change="changeType($event)">
      <option
        v-for="(value, key) in COMP_TYPE"
        :key="key"
        :value="key.toLowerCase()"
        :selected="getCompType(key)"
      >
        {{ value }}
      </option>
    </select>
  </div>
</template>

<script>
import Tooltip from "./Tooltip.vue";
import {
  AREA_COMP_TYPE,
  FIELD_SPECIAL_COMP,
  FIELD_COMP_TYPE,
  ROOT_NODE,
  TOOLTIP_TEXT,
} from "../mixins/constant-mixin";
import { Bus } from "../main";

export default {
  name: "TypeField",
  props: {
    root: {
      type: String,
    },
    type: {
      type: String,
    },
    limitCompType: {
      type: String,
    },
  },
  data() {
    return {
      FIELD_COMP_TYPE: FIELD_COMP_TYPE,
      AREA_COMP_TYPE: AREA_COMP_TYPE,
      ROOT_NODE: ROOT_NODE,
      TOOLTIP_TEXT: TOOLTIP_TEXT,
    };
  },
  components: {
    tooltip: Tooltip,
  },
  computed: {
    COMP_TYPE: function () {
      let list = {};
      if (this.limitCompType === ROOT_NODE.FIELDS) {
        list = FIELD_COMP_TYPE;
      } else if (this.limitCompType === ROOT_NODE.AREAS) {
        let staticComp = {};
        Object.keys(FIELD_COMP_TYPE)
          .filter((type) => FIELD_SPECIAL_COMP.indexOf(type) === -1)
          .forEach((type) => (staticComp[type] = FIELD_COMP_TYPE[type]));
        list = { ...staticComp, ...AREA_COMP_TYPE };
      } else {
        list = { ...FIELD_COMP_TYPE, ...AREA_COMP_TYPE };
      }
      return list;
    },
  },
  methods: {
    changeType: function (event) {
      Bus.$emit("changeType", event.target.value.toUpperCase());
    },
    getCompType: function (type) {
      return type.toLowerCase() === this.type.toLowerCase();
    },
  },
};
</script>

<style scoped>
.input-block {
  display: flex;
  flex-direction: column;
}

.input-block input,
.input-block select {
  padding: 8px;
  margin-top: 4px;
}

.required {
  color: #f00;
}
</style>